// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"126":"915679e55fbdae3d","581":"cbd9ea38191287bb"}[chunkId] + ".css";
};